import { IDatasetTypeMetadata, IDynamicDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { extendedColumnTypes } from 'app/shared/utils/column-type.util';
import { format } from 'app/shared/utils/string.util';
import { maxConcurrentConnectionsMetadata, preCopyScriptMetadata } from '../consts/metadata-consts';
import { Constants } from 'shell-models-lib';

export const mysqlTableMetadata: IDynamicDatasetTypeMetadata = async () => {
    const metadata: IDatasetTypeMetadata = {
        type: adfModelTypeMap.mysql.datasetType,
        displayName: stringResources.MySql_DisplayText,
        supportLinkedServiceTypes: [adfModelTypeMap.mysql.linkedServiceType],
        isSource: true,
        isSink: __IS_FABRIC_DPE__,
        datasetKind: 'table',
        showWarningMessage: '{ linkedService && linkedService.driverVersion !== "v2" }',
        warningMessage: format(
            stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
            stringResources.DriverVersion.toLocaleLowerCase()
        ),
        warningMessageHyperlink:
            'https://learn.microsoft.com/azure/data-factory/connector-mysql',
        supportDataTypes: extendedColumnTypes,
        icon: {
            className: 'svg-i-100x100-MySQL'
        },
        isFirstClass: true,
        supportCreatedAsV2: true,
        notSupportPhysicalType: true,
        v1SupportSchema: true,
        category: ['Database'],
        copySourceControls: [],
        copySinkControls: __IS_FABRIC_DPE__ ? [
            preCopyScriptMetadata(),
            {
                type: 'parameterizable',
                child: {
                    type: 'textbox',
                    bind: 'writeBatchTimeout',
                    label: stringResources.ModelName_WriteBatchTimeout,
                    validators: [
                        {
                            type: 'pattern',
                            pattern: Constants.timeoutValidationPattern,
                            errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                        }
                    ]
                },
                dynamicContentTextClass: 'input-spaced'
            },
            {
                type: 'parameterizable',
                child: {
                    type: 'textbox-number',
                    bind: 'writeBatchSize',
                    label: stringResources.ModelName_WriteBatchSize,
                    inputType: 'number',
                    min: 0
                },
                dynamicContentTextClass: 'input-spaced'
            },
            maxConcurrentConnectionsMetadata
        ] : [],
        copyJob: {
            multipleQuery: true
        }
    };
    return metadata;
};
